import StageVoid from './styled';

export default StageVoid;
